<template>
  <div class="tag-container tag-tooltip tag-tooltip-bottom">
    <div
      v-if="text"
      :style="cssVars"
      class="search-tag pill"
    >
      <span class="text">
        {{ text }}
      </span>
      <button
        type="button"
        class="icon"
        :aria-label="$t('events.removeSearchTagAriaLabel', { tagName: text })"
        @click="onRemove"
      >
        <RemoveIcon aria-hidden="true" />
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import RemoveIcon from '../../icons/RemoveIcon.vue';

defineOptions({ name: 'SearchTag' });

const props = defineProps({
  text: {
    type: String,
    default: '',
  },
  bgColor: {
    type: String,
    default: '#F3F3F3',
  },
  fontColor: {
    type: String,
    default: '#000',
  },
  onRemove: {
    type: Function,
    default: () => ({}),
  },
});

const cssVars = computed(() => ({
  '--bg-color': props.bgColor,
  '--font-color': `${props.fontColor}CC`,
}));
</script>

<style lang="scss" scoped>
.tag-container {
  min-height: 24px;
  height: auto;
  padding: 8px;
  background-color: #fbfbfb;
  border: none;
  border-bottom: 1px solid #adadad;
  border-radius: 4px 4px 0 0;
  transition: 0.2s ease;
  color: var(--input-font-color);
  transition: background-color 0.5s;
}

.search-tag {
  height: fit-content;
  min-height: 24px;
  width: fit-content;
  max-width: 150px;
  background: var(--bg-color);
  color: var(--font-color);
  font-weight: 400;
  cursor: default;
  text-transform: capitalize;
  margin-right: 8px;
  display: inline-flex;
  align-items: flex-start;

  .text {
    max-width: 8em;
    display: inline;
    word-wrap: break-word;
    overflow-wrap: break-word;
    hyphens: auto;
  }

  .icon {
    cursor: pointer;
    border: none;
    align-self: center;
    margin-left: 4px;
    svg {
      margin: auto;
    }
  }

  &.pill {
    padding: 4px 12px;
    border-radius: 4px;
    font-size: 14px;
    line-height: 1.2;
  }
}

.tag-tooltip {
  position: relative;
  display: inline-block;
  width: -webkit-fill-available;
  width: -moz-available;
  .tag-tooltip-text {
    visibility: hidden;
    width: fit-content;
    max-width: 200px;
    background: #333333;
    text-align: center;
    border-radius: 3px;
    padding: 5px;
    position: absolute;
    z-index: 1;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
    font-style: normal;
    font-weight: 450;
    font-size: 11px;
    line-height: 12px;
    letter-spacing: 0.4px;
    color: #ffffff;

    transition: 0s visibility;

    &::after {
      content: '';
      position: absolute;
      border-width: 5px;
      border-style: solid;
    }
  }

  &:hover .tag-tooltip-text {
    visibility: visible;
    transition-delay: 1s;
  }

  &.tag-tooltip-bottom {
    .tag-tooltip-text {
      top: 120%;
      left: 10%;

      &::after {
        bottom: 100%;
        left: 50%;
        border-color: transparent transparent #2e2e2e transparent;
      }
    }
  }
}
</style>
